import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBlog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#TwoColorBlog_svg__a)">
      <path
        fill="#F7A600"
        d="M11.898.75a.613.613 0 0 0-.648.61v1.204c0 .324.251.59.571.605 4.929.267 8.89 4.266 9.175 9.198.02.32.286.571.606.571h1.222c.35 0 .629-.297.61-.647-.324-6.216-5.32-11.213-11.537-11.54Zm.01 3.657a.614.614 0 0 0-.658.613v1.223c0 .32.248.583.564.605 2.925.24 5.256 2.598 5.518 5.53.03.317.29.56.606.56h1.226c.354 0 .64-.304.613-.659-.32-4.193-3.675-7.548-7.868-7.872Z"
      />
      <path
        fill={getTheme(props["data-theme"])}
        d="M.75 14.25a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z"
      />
      <path
        fill="#F7A600"
        d="M11.25 15.115H8.972c-.15 0-.292.061-.398.17a.584.584 0 0 0 0 .815.556.556 0 0 0 .398.17h2.278c.15 0 .292-.062.398-.17a.585.585 0 0 0 0-.816.555.555 0 0 0-.398-.169Zm-2.278-1.73h1.462c.15 0 .293-.061.398-.17a.584.584 0 0 0 0-.815.556.556 0 0 0-.398-.17H8.972c-.15 0-.292.062-.398.17a.585.585 0 0 0 0 .816.555.555 0 0 0 .398.169Zm3.403-.577v.577c0 .153.06.3.165.408a.555.555 0 0 0 .398.168c.149 0 .292.061.397.17a.585.585 0 0 1 .165.408v1.73c0 .46-.178.9-.494 1.224a1.666 1.666 0 0 1-1.194.507H8.438c-.448 0-.877-.182-1.194-.507a1.754 1.754 0 0 1-.494-1.224v-4.038c0-.46.178-.9.494-1.224a1.666 1.666 0 0 1 1.194-.507h2.25c.447 0 .876.182 1.193.507.316.325.494.765.494 1.224v.577Z"
      />
    </g>
    <defs>
      <clipPath id="TwoColorBlog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwoColorBlog;
